<template>
	<validation-provider
			:name="'AdminRadioButton-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			mode="lazy"
			v-slot="{ errors }">
		<v-radio-group
				class="radioGroup_"
				v-model="$store.state.admin.input[inputItemKey]"
				:disabled="contents[contentKey].inputItems[inputItemKey].disabled"
				row
				:error-messages="errors">
			<template v-for="(optionVals, optionKey) in contents[contentKey].inputItems[inputItemKey].options">
				<v-radio 
						class="radio_"
						:key="optionKey"
						:label="optionVals.title"
						:value="optionKey" />
			</template>
		</v-radio-group>
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminRadioButton',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		}
	}
</script>

<style scoped>
	.radioGroup_ {
		margin-top: 0;
	}
	.radio_ {
		margin-top: 20px;
		margin-bottom: 0 !important;
	}
</style>
